import { render, staticRenderFns } from "./MemberGrade.vue?vue&type=template&id=6e5aa5d5&"
import script from "./MemberGrade.vue?vue&type=script&lang=ts&"
export * from "./MemberGrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports